/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LoaMetadata,
    LoaMetadataFromJSON,
    LoaMetadataFromJSONTyped,
    LoaMetadataToJSON,
} from './LoaMetadata';
import {
    LoaTrustCertificate,
    LoaTrustCertificateFromJSON,
    LoaTrustCertificateFromJSONTyped,
    LoaTrustCertificateToJSON,
} from './LoaTrustCertificate';

/**
 * 
 * @export
 * @interface LoaTrust
 */
export interface LoaTrust {
    /**
     * 
     * @type {string}
     * @memberof LoaTrust
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof LoaTrust
     */
    thumbPrint?: string;
    /**
     * 
     * @type {LoaMetadata}
     * @memberof LoaTrust
     */
    loaMetadata?: LoaMetadata;
    /**
     * 
     * @type {string}
     * @memberof LoaTrust
     */
    x509CertificateB64Str?: string;
    /**
     * 
     * @type {LoaTrustCertificate}
     * @memberof LoaTrust
     */
    certificate?: LoaTrustCertificate;
}

export function LoaTrustFromJSON(json: any): LoaTrust {
    return LoaTrustFromJSONTyped(json, false);
}

export function LoaTrustFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoaTrust {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'thumbPrint': !exists(json, 'thumbPrint') ? undefined : json['thumbPrint'],
        'loaMetadata': !exists(json, 'loaMetadata') ? undefined : LoaMetadataFromJSON(json['loaMetadata']),
        'x509CertificateB64Str': !exists(json, 'x509CertificateB64Str') ? undefined : json['x509CertificateB64Str'],
        'certificate': !exists(json, 'certificate') ? undefined : LoaTrustCertificateFromJSON(json['certificate']),
    };
}

export function LoaTrustToJSON(value?: LoaTrust | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'thumbPrint': value.thumbPrint,
        'loaMetadata': LoaMetadataToJSON(value.loaMetadata),
        'x509CertificateB64Str': value.x509CertificateB64Str,
        'certificate': LoaTrustCertificateToJSON(value.certificate),
    };
}

